import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { catchError, filter, first, map, Observable, of, timeout } from 'rxjs';
import { AppSelectors } from '../store/app/app.selectors';
import { SetSessionExpired } from '../store/app/app.actions';

@Injectable({ providedIn: 'root' })
class TermsAcceptGuard {
  readonly store = inject(Store);
  readonly router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.store.select(AppSelectors.hasAcceptedLatestTerms).pipe(
      filter((termsAccepted) => termsAccepted !== undefined),
      first(),
      timeout(10000), // 10 second timeout to prevent hanging if state never loads
      catchError(() => {
        // If the state never loads, trigger session expired flow
        this.store.dispatch(new SetSessionExpired(true));
        return of(false);
      }),
      map((termsAccepted) => {
        if (!termsAccepted) {
          this.router.navigate(['update/terms-of-use']);
        }
        return Boolean(termsAccepted);
      }),
    );
  }
}
export const canActivateTermsAcceptGuard: CanActivateFn = () => {
  return inject(TermsAcceptGuard).canActivate();
};
